import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

const STORAGE_KEY = 'theme';

export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(localStorage.getItem(STORAGE_KEY) !== 'light');

  function applyTheme() {
    document.documentElement.classList.toggle('light-theme', !isDark.value);
    localStorage.setItem(STORAGE_KEY, isDark.value ? 'dark' : 'light');
  }

  function toggleTheme() {
    isDark.value = !isDark.value;
    applyTheme();
  }

  // Инициализация при первом импорте
  applyTheme();

  // Реагирование на изменения
  watch(isDark, applyTheme, { immediate: false });

  return { isDark, toggleTheme };
});
